/* eslint-disable react/jsx-no-useless-fragment */
import React, { FC, ReactNode } from 'react';

interface CombinedComponentProps {
	children: ReactNode;
}

interface ComponentConfig {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Component: FC<any>;
	value?: object;
}

// source: https://javascript.plainenglish.io/how-to-combine-context-providers-for-cleaner-react-code-9ed24f20225e
export const combineComponents = (...components: ComponentConfig[]): FC<CombinedComponentProps> => {
	return components.reduce(
		(AccumulatedComponents, { Component, value }) => {
			return ({ children }: CombinedComponentProps): JSX.Element => {
				return (
					<AccumulatedComponents>
						<Component {...value}>{children}</Component>
					</AccumulatedComponents>
				);
			};
		},
		({ children }: CombinedComponentProps) => <>{children}</>
	);
};
